import React from 'react';
import { KFLDialog, KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { connect } from 'react-redux';
import Translate from '../shared/localization/localize';
import DialogHeader from '../shared/dialog/dialogHeader';
import DialogFooter from '../shared/dialog/dialogFooter';
import { ReduxState } from '../../interfaces';
import * as ReadRights from '../../modules/dialogs/readRights';
import Spinner from '../shared/spinner';
import UserDetailsForm from '../shared/userInfoRetriever/userDetailsForm';
import useUserInfo, {
  UseUserInfoData,
  UseUserInfoDataDefaultByUser,
} from '../../hooks/useUserInfo';

import './readRights.scss';
import useDialog from '../shared/dialog/useDialog';
import { Settings } from '../../variables';

type StateProps = ReadRights.State;

type Props = StateProps;

const ReadRightAssignDialog: React.FC<Props> = (props: Props) => {
  const {setDialog} = useDialog();
  const userInfoHook = useUserInfo(
    UseUserInfoDataDefaultByUser(props.addressee),
    (u: UseUserInfoData) => ReadRights.updateAssignee(u.userInfo)
  );
  const isCreateNAssign =
    props.addressee.email.length > 0 &&
    props.addressee.customer.customerId.length === 0;
  const hasCustomer = props.addressee.customer.customerId.length !== 0;
  const btnAssign = isCreateNAssign ? (<KFLButton
    id="readrights-assigncreate"
    disabled={true}
    onClick={() => console.log('Please, register the user first.')}
  >
    <Translate message={ReadRights.msgAssignBtn} />
  </KFLButton>) : (
    <KFLButton
      id="readrights-assign"
      disabled={props.assignCall.isFetching || !hasCustomer}
      onClick={() => ReadRights.assign()}
    >
      <Translate message={ReadRights.msgAssignBtn} />
    </KFLButton>
  );

  const content = (
    <div>
      <UserDetailsForm id="readrights-assign" {...userInfoHook} />
      <div>
        <div>
          {isCreateNAssign ? (
            <>
              <Translate message={ReadRights.warnUserToAssignNotFound} />
              <br />
              <Translate message={ReadRights.registerUserToAssign} />[
              <a href={Settings.ENV_LOGINREGISTER_URL} target='tab'>
                <Translate message={ReadRights.registerHere} />
              </a>
              ].
            </>
          ) : (
            <Translate
              message={
                hasCustomer
                  ? ReadRights.warnUserFound(
                      props.addressee.customer.customerName
                    )
                  : ''
              }
            />
          )}
        </div>
        <div></div>
      </div>
    </div>
  );

  const footerLeft = props.assignCall.isFetching ? (
    <Spinner label={ReadRights.msgUpdating} iconSize={20} />
  ) : (
    <></>
  );

  return (
      <KFLDialog
        header={
          <DialogHeader
            title={<Translate message={ReadRights.msgAssignHeader} />}
            fnCloseDialog={() => setDialog?.()}
          />
        }
        sections={[content]}
        footer={
          <DialogFooter
            leftContent={footerLeft}
            buttons={[btnAssign]}
            fnCloseDialog={() => setDialog?.()}
          />
        }
      />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ...state.dialogState.readrightState,
});

export default connect(mapStateToProps)(ReadRightAssignDialog);
